import service from './axios'

export const getHomeData = (data) => {
  return service.post('/h5-home', data)
}

export const chapterLoad = (data) => {
  return service.post('/chapter/load', data)
}

export const quickOpen = (data) => {
  return service.post('/book/quick/open', data)
}

export const getChapterList = (data) => {
  return service.post('/chapter/list', data)
}

export const praise = (data) => {
  return service.post('/chapter/praise', data)
}

export const getSearchRecommend = (data) => {
  return service.post('/book/search/recommend', data)
}

export const getSearchList = (data) => {
  return service.post('/book/search/seo', data)
}

export const login = (data) => {
  return service.post('/user/login', data)
}

export const getUserInfo = (data) => {
  return service.post('/profile/user/info', data)
}

export const createOrder = (data) => {
  return service.post('/pay/create/tiktok/order', data)
}

export const addToLibrary = (data) => {
  return service.post('/shelf/add', data)
}

export const removeFromLibrary = (data) => {
  return service.post('/shelf/delete/batch', data)
}

export const removeFromLibraryByBookId = (data) => {
  return service.post('/shelf/delete/batch2', data)
}

// 播放记录
export const setPlayStatus = (data) => {
  return service.post('/book/read/status/update', data)
}

// 书架
export const getShelfList = (data) => {
  return service.post('/shelf/list', data)
}

export const getChapterRecommend = (data) => {
  return service.post('/chapter/end/recommend', data)
}

export const getHistoryList = (data) => {
  return service.post('/shelf/list/recently', data)
}

export const deleteHistory = (data) => {
  return service.post('/shelf/delete/batch/recently', data)
}

export const getUnlockHistory = (data) => {
  return service.post('/profile/consume/history/list', data)
}

// 订阅相关接口
// 订阅档位列表（独立接口，不依赖 chapter/load）
export const getSubscriptionList = (data) => {
  const formData = new FormData()
  if (data) {
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== '') {
        formData.append(key, data[key])
      }
    })
  }
  return service.post('/pay/subscription/list', formData)
}

// 续订（reactivate）
export const reactivateSubscriptionOrder = (data) => {
  return service.post('/pay/subscription/renew', data)
}

// 验单
export const subscriptionState = (data) => {
  return service.post('/pay/subscription/state', data)
}